import { OpenAPI } from '@/client';

export type CacheScope =
  | 'config'
  | 'categories'
  | 'ad_config'
  | 'app_decor'
  | 'home_list'
  | 'home_recommended';

export const DEFAULT_CACHE_SCOPES: CacheScope[] = ['home_list', 'app_decor'];

export const cacheScopeGroups: Array<{
  title: string;
  options: Array<{ label: string; value: CacheScope }>;
}> = [
  {
    title: '默认建议',
    options: [
      { label: '漫画列表缓存', value: 'home_list' },
      { label: '装修缓存', value: 'app_decor' },
    ],
  },
  {
    title: '配置缓存',
    options: [
      { label: '客户端配置缓存', value: 'config' },
      { label: '分类缓存', value: 'categories' },
      { label: '首页推荐缓存', value: 'home_recommended' },
    ],
  },
  {
    title: '广告缓存',
    options: [{ label: '广告配置和实验下发缓存', value: 'ad_config' }],
  },
];

type ClearClientCacheResponse = {
  deleted_keys: number;
  patterns: string[];
  scheduled?: boolean;
};

export type CachePackageTenantRoute = {
  bundle_id: string;
  platform: string;
  tenant_id: number;
  tenant_code: string;
  tenant_name: string;
  package_id?: string | null;
  current_tenant_matched: boolean;
};

export type CachePackageTenantResponse = {
  current_tenant_code?: string | null;
  current_tenant_name?: string | null;
  matches: CachePackageTenantRoute[];
};

async function getTokenValue(): Promise<string> {
  if (typeof OpenAPI.TOKEN === 'function') {
    return OpenAPI.TOKEN({} as never);
  }
  return OpenAPI.TOKEN || '';
}

export async function clearClientCache(scopes: CacheScope[]): Promise<ClearClientCacheResponse> {
  const token = await getTokenValue();
  const response = await fetch(`${OpenAPI.BASE}/api/v2/system/cache/clear`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify({ scopes }),
  });

  if (!response.ok) {
    const text = await response.text();
    throw new Error(text || `HTTP ${response.status}`);
  }

  return response.json() as Promise<ClearClientCacheResponse>;
}

export async function lookupCachePackageTenant(params: {
  bundle_id?: string;
  platform?: string;
  limit?: number;
}): Promise<CachePackageTenantResponse> {
  const token = await getTokenValue();
  const query = new URLSearchParams();
  if (params.bundle_id?.trim()) query.set('bundle_id', params.bundle_id.trim());
  if (params.platform?.trim()) query.set('platform', params.platform.trim());
  if (params.limit) query.set('limit', String(params.limit));
  const response = await fetch(
    `${OpenAPI.BASE}/api/v2/system/cache/package-tenant?${query.toString()}`,
    {
      headers: {
        Accept: 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    },
  );

  if (!response.ok) {
    const text = await response.text();
    throw new Error(text || `HTTP ${response.status}`);
  }

  return response.json() as Promise<CachePackageTenantResponse>;
}
